import React from 'react'
import styled from '@emotion/styled'
import { MultiButton, MultiButtonProps } from './MultiButton'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'

export enum TextFlagState {
  On,
  Off,
  Mid
}

export const getTextFlagButtonState = (on: boolean) => (on ? TextFlagState.On : TextFlagState.Off)

const getTextFlagColor = (state: TextFlagState) => {
  return state === TextFlagState.On
    ? constants.CORE_PRIMARY
    : state === TextFlagState.Mid
    ? constants.CORE_PRIMARY
    : constants.CORE_PRIMARY_5
}

const getTextFlagBackgroundColor = (state: TextFlagState) => {
  return state === TextFlagState.On
    ? constants.ACCENT_PRIMARY
    : state === TextFlagState.Mid
    ? constants.ACCENT_PRIMARY_3
    : constants.CORE_PRIMARY_2
}

const TextFlagButtonStyled = styled(MultiButton)<{ state: TextFlagState }>`
  ${mixins.flexCenterContentCrossAxis};
  padding: 0 7px;
  height: 100%;
  max-height: 30px;
  font-size: 10px;
  font-weight: ${constants.FontWeight.Bold};
  color: ${props => getTextFlagColor(props.state)};
  background-color: ${props => getTextFlagBackgroundColor(props.state)};
  &:hover {
    color: ${constants.CORE_PRIMARY};
    background-color: ${constants.ACCENT_PRIMARY_1};
  }
  &[disabled] {
    opacity: 0.6;
  }
  &:first-of-type {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  &:last-of-type {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`

export const TextFlagButton = (props: MultiButtonProps & { state: TextFlagState }) => {
  return <TextFlagButtonStyled aria-pressed={props.state === TextFlagState.On} {...props} />
}

export const TextFlagButtonsContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  height: 26px;
`
